import React from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '@store/root-reducer';
import Button from '@pezeshk-book/ui-kit/button';
import { ReplyCommentInterface } from './reply-button.props';
import { useParams } from 'next/navigation';
import getDictionary from '@dictionaries-client';

const ReplyButton = ({ replyHandler, loginHandler }: ReplyCommentInterface) => {
  const { isLoggedIn } = useSelector((state: RootState) => state.auth);
  const { lang } = useParams<{lang : 'fa'|'en'}>();
  const { modules: { comment } } = getDictionary(lang);

  if (isLoggedIn) {
    return (
      <Button
        onClick={replyHandler}
        variant={'outlined'}
        fontType={'medium'}
        size={'tiny'}
        rounded={'small'}
        className={'self-end'}>
        {comment.buttons.reply}
      </Button>
    );
  }

  return null;
};

export default ReplyButton;
